import { TableContainer, Table, TableRow, TableCell, Skeleton, TableBody, TableHead, Box } from "@mui/material";
import { useTablaCarpetaContext } from "../logics/TablaCarritoProvider";

const LoadingRows = () => {
    const { context } = useTablaCarpetaContext();
    const { perPage } = context;
    return (
        <TableContainer>
            <Table sx={{ minWidth: 750, overflow: 'hidden' }} aria-labelledby="tableTitle" size='medium'>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Skeleton variant="text" width={150} animation="wave" />
                        </TableCell>
                        <TableCell>
                            <Skeleton variant="text" width={150} animation="wave" />
                        </TableCell>
                        <TableCell>
                            <Skeleton variant="text" width={100} animation="wave" />
                        </TableCell>
                        <TableCell>
                            <Skeleton variant="text" width={150} animation="wave" />
                        </TableCell>
                        <TableCell align="center">
                            <Skeleton variant="text" width={80} animation="wave" />
                        </TableCell>
                        <TableCell align="center">
                            <Skeleton variant="text" width={100} animation="wave" />
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {[...Array(perPage)].map((_, index) => (
                        <TableRow key={index}>
                            <TableCell padding="checkbox">
                                <Box sx={{ display: 'flex', justifyContent: 'center', columnGap: '10px' }}>
                                    <Skeleton variant="rectangular" width={20} height={20} animation="wave" sx={{ borderRadius: '10px', alignSelf: 'center' }} />
                                    <Skeleton variant="text" width={150} animation="wave" />
                                </Box>
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="text" width={150} animation="wave" />
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="text" width={100} animation="wave" />
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="text" width={150} animation="wave" />
                            </TableCell>
                            <TableCell align="center">
                                <Skeleton variant="text" width={80} animation="wave" />
                            </TableCell>
                            <TableCell align="center">
                                <Skeleton variant="text" width={100} animation="wave" />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default LoadingRows;